var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-registration"},[_c('div',{staticStyle:{"text-align":"center","font-weight":"600","font-size":"20px"}},[_vm._v(" "+_vm._s(_vm.$t('Home.Home.Register.Description'))+" ")]),_c('div',{},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }